import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=4c570686&"
import script from "./FileField.vue?vue&type=script&lang=ts&"
export * from "./FileField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports